import formatDuration from 'date-fns/formatDuration';
import intervalToDuration from 'date-fns/intervalToDuration';
import type { ActiveTicket } from '@/common/api/models.pleased';

const isCommentBodyAlreadyPrefixedWithAuthor = (body: string, author: string): boolean => {
  if (!author) return false;
  return body.trimStart().startsWith(`${author}:`);
};

/** Same preview string as the active-conversations list in Chatroom (`updateActiveConversationList`). */
export const getActiveTicketLatestCommentPreview = ({ latestComment }: ActiveTicket): string => {
  if (!latestComment) return '';

  const { voice, body, authorName, authorType } = latestComment;
  if (voice) {
    return `Voice Call of ${formatDuration(intervalToDuration({ start: 0, end: voice.duration * 1000 }), {
      format: ['minutes', 'seconds'],
    })}`;
  }
  const author = authorType === 'AGENT' ? authorName : 'You';
  if (author && isCommentBodyAlreadyPrefixedWithAuthor(body, author)) {
    return body;
  }
  return author ? `${author}: ${body}` : body;
};
